//<Text style={styles.threatBottomRight}>{this.roundText(this.state.totalPower)}</Text>
			//<View style={styles.threatBottomRight}>
              //<ThreatCounter update={this.getPower.bind(this)}/>
            //</View>


import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, Easing, Image, Pressable} from 'react-native';


const fps = 60;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

class ThreatCounter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      threat: 0,
    }
    
    this.getThreat = this.props.update;

  }

  componentDidMount() {
    this.interval = setInterval(function() {
			let newThreat = this.getThreat()
			if (newThreat != this.state.threat) {
            	this.setState({threat: newThreat});
			}
          }.bind(this), fpsDuration);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  roundText(number) {
    if (Math.ceil(number) - number < MYEPSILON) {
      return Math.ceil(number);
    }
    return Math.floor(number);
  }

  render() {
	  //console.log(this.state.threat)
    return (
        <Text style={styles.threat}>{this.roundText(this.state.threat)}</Text>
    );
  }
}

const styles = StyleSheet.create({
  threat: {
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
  },
});

export default ThreatCounter;